let $lozad_init = false;

(function (Drupal) {
  Drupal.behaviors.lozadInit = {
    attach: function (context, settings) {

      if (document.querySelectorAll('.b-lazy').length) {
        const observer = lozad(document.querySelectorAll('.b-lazy'), {
          rootMargin: '10px 0px', // syntax similar to that of CSS Margin
          threshold: 0.1, // ratio of element convergence
          enableAutoReload: true, // it will reload the new image when validating attributes changes
          loaded: (el) => {

          }
        });
        observer.observe();

        $lozad_init = true;
      }

    }
  }
})(Drupal);
